import classNames from 'classnames';

export const FooterBottomItem: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return (
    <div className={classNames('text-[12px]/[15.12px] text-white md:text-[14px]/[17.64px]', className)}>{children}</div>
  );
};
